import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import MuiRadioGroup from '@mui/material/RadioGroup';
import Radio from '@cpg-its/ads.common.radio';
import FormControlLabel from '@cpg-its/ads.form.form-control-label';
import FormLabel from '@cpg-its/ads.form.form-label';
const radioGroupStyles = {
    displayRow: {
        flexDirection: 'row',
    },
};
export const RadioGroupComponent = ({ beenTouched = false, disabled = false, field: { name: fieldName, value: fieldValue } = {}, form: { setFieldValue } = {}, hasError = false, label = '', name = '', onBlur = () => { }, onChange = () => { }, onClick = () => { }, options = [], required = false, row = false, subLabel = '', testId = undefined, tooltip = {}, value = '', }) => {
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
        if (setFieldValue) {
            setFieldValue(fieldName || name, event.target.value);
        }
    };
    const renderRadioButtons = (() => (options.map((option) => (_jsx(FormControlLabel, { control: (_jsx(Radio, { beenTouched: beenTouched, hasError: hasError, disabled: disabled, value: option.value, checked: option.value === (fieldValue || value), onClick: option.onClick || onClick })), label: option.label, labelColor: option.labelColor, description: option.description }, option.value)))))();
    const groupLabel = (() => {
        if (label) {
            return (_jsx(FormLabel, { label: label, required: required, subLabel: subLabel, tooltip: tooltip }));
        }
        return null;
    })();
    return (_jsxs(_Fragment, { children: [groupLabel, _jsx(MuiRadioGroup, { sx: row ? radioGroupStyles.displayRow : {}, "data-formdata": fieldName || name, "data-testid": testId, onBlur: onBlur, onChange: handleChange, value: fieldValue || value, children: renderRadioButtons })] }));
};
export default RadioGroupComponent;
//# sourceMappingURL=radio-group.js.map